import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    margin: theme.spacing(-2, 0, 7.51, 0),
  },
  content: {
    marginTop: theme.spacing(4),
    display: 'flex',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
}))
